/*
 * 아이폰·아이패드 앱(apps/ios) 안에서 열렸을 때 앱과 주고받는 통로.
 * 앱이 window.webkit.messageHandlers.justone을 넣어 주고, postMessage의 답을 Promise로 돌려준다.
 */

type Handler = { postMessage(message: unknown): Promise<unknown> };

const handler = (): Handler | undefined => (window as { webkit?: { messageHandlers?: { justone?: Handler } } }).webkit?.messageHandlers?.justone;

/** JustOne 앱 안에서 열렸으면 true */
export const inNativeApp = () => !!handler();

export async function callNative<T>(type: string, params: Record<string, unknown> = {}): Promise<T> {
  const h = handler();
  if (!h) throw new Error("JustOne 앱 안이 아닙니다.");
  return (await h.postMessage({ type, ...params })) as T;
}

/** iPhone·iPad (iPad의 Safari는 Mac처럼 보이므로 터치로 가린다) */
export const isIOS = () => /iPhone|iPad|iPod/.test(navigator.userAgent) || (navigator.platform === "MacIntel" && navigator.maxTouchPoints > 1);

/** 링크로 앱을 설치하는 주소 (서버의 /ios/manifest.plist, routes/ios.ts) */
export const iosInstallUrl = () => `itms-services://?action=download-manifest&url=${encodeURIComponent(`${location.origin}/ios/manifest.plist`)}`;
